export default __webpack_public_path__ + "static/suit-room-e9cf21fb1088758661300346ac0fc539.jpg";